/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackerform', {
      restrict: 'E',
      bindings: {
        tracker: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vctracker/trackerform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          vm.defsave = defsave;
          vm.addDef = addDef;
          vm.removeDef = removeDef;

/*          vm.$onInit = function () {
            if (angular.isUndefined(vm.tracker.def)) {
              vm.tracker.def = [];
            }
            vm.lasttracker = angular.copy(vm.tracker);
          };*/

          // tracker arrive late!
          vm.$onChanges = function (changes) {
            if (angular.isDefined(vm.tracker) && angular.isObject(vm.tracker)) {
              if (angular.isUndefined(vm.tracker.def)) {
                vm.tracker.def = [];
              }
              vm.lasttracker = angular.copy(vm.tracker);
            }
          };

          function save() {
            if (!angular.equals(vm.tracker, vm.lasttracker)) {
              vm.lasttracker = angular.copy(vm.tracker);
              vm.parentsave({tracker: vm.tracker});
            }
          }

          function cancel() {
            vm.tracker = angular.copy(vm.lasttracker);
            vm.oncancel();
          }

          function defsave(trackerdef, index) {
            $log.debug('debug: trackerform defsave called: ', trackerdef);
            vm.tracker.def[index] = angular.copy(trackerdef);
            // vm.tracker.postcode = zip;
            // vm.tracker.city = city;
          }

          function addDef() {
            vm.tracker.def.push({
              label: '',
              unit: '',
              step: 0,
              normmin: 0,
              normmax: 100,
              absmin: 0,
              absmax: 100
            });
          }

          function removeDef(index) {
            vm.tracker.def.splice(index, 1);
          }

        }] // controller
    }); // component

// klammerfriedhof
}());